module.exports = __webpack_public_path__ + "static/img/alert-icon.f2e97163.svg";